<template>
    <v-toolbar
            :color="options.color"
            flat
    >
        <v-btn
                v-if="options.allowBack"
                icon
                @click="routerGoBack()"
        >
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
</template>


<script>
    import RouterService from "@/helpers/RouterService.js";

    export default {
        name: "ContentToolbar",
        props: ["title", "options",],
        data() {
            return {};
        },
        methods: {
            routerGoBack() {
                RouterService.goBack();
            },
        },
    };
</script>

<style scoped>

</style>

